import React, {createContext, FC, useEffect, useState} from "react";
import {MAIN_TAB, TabKey} from "../constants/tabs";
import {getElementByIdFromIframe} from "../utils/dom";

// the key of the active tab, see constants/tabs
export const TabsContext = createContext<[TabKey, React.Dispatch<TabKey>]>([
  MAIN_TAB,
  () => null,
]);

export const TabsContextProvider: FC = ({ children }) => {
  const [fieldValue, setFieldValue] = useState<TabKey>(MAIN_TAB);

  useEffect(() => {
    if (fieldValue !== MAIN_TAB) {
      const element = getElementByIdFromIframe('root-content')
      element?.scrollTo(0,0)
    }
  }, [fieldValue])

  return (
    <TabsContext.Provider value={[fieldValue, setFieldValue]}>
      {children}
    </TabsContext.Provider>
  );
};
